// extracted by mini-css-extract-plugin
export var csatScore = "_lm-5";
export var header = "_lm-1";
export var panelWrapper = "_lm-2";
export var postPreview = "_lm-3";
export var rightContent = "_lm-0";
export var wrappingText = "_lm-4";